var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.card,on:{"click":_vm.openModal}},[_c('div',{class:_vm.$style.simulationContainer,attrs:{"data-test-id":_vm.$testId(_vm.label)}},[_c('img',{class:_vm.$style.thumbnail,attrs:{"src":"img/growth/home-resources-simulation-thumbnail.png"}}),_c('p',{class:_vm.$style.label},[_vm._v(" "+_vm._s(_vm.label)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }